export enum SignupStep {
    VERIFICATION = 'VERIFICATION',
    ACCOUNT = 'ACCOUNT',
    TEAM = 'TEAM',
}
